import { render, staticRenderFns } from "./Innovation.vue?vue&type=template&id=7969f80c&scoped=true&"
import script from "./Innovation.vue?vue&type=script&lang=js&"
export * from "./Innovation.vue?vue&type=script&lang=js&"
import style0 from "./Innovation.vue?vue&type=style&index=0&id=7969f80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7969f80c",
  null
  
)

export default component.exports